import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';

/** 上传图片到服务器 */
export async function uploadImgToServer(file: File, action: string) {
  let data = {} as any;

  const formData = new FormData();

  formData.append('file', file);
  formData.append('name', 'file');

  try {
    const { code, context, message } = await Http.post<any>(action, formData);

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || {};

      data = res || {} as any;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}
